import { INTEGRATION_PARTNERS } from 'config/types';
import { useConfig } from 'context/app-config';
import React from 'react';

import { AddressComponents } from './standalone';

interface Props {
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;
  isLoading: boolean;
  disabled?: boolean;
  actionButtonProps?: {
    isLoading?: boolean;
  };
}

export const AdapterAddressModule: React.FC<Props> = ({ show, onClose, onSubmit, isLoading, disabled, actionButtonProps }) => {
  const config = useConfig();

  let AddressComponent;

  switch (config?.addressFlow) {
    case INTEGRATION_PARTNERS.CAREEM:
      AddressComponent = AddressComponents.CareemAddressSheet as unknown as React.FC<Props>;
      break;
    default:
      AddressComponent = AddressComponents.AddressSheet as unknown as React.FC<Props>;
      break;
  }

  return (
    <AddressComponent
      actionButtonProps={actionButtonProps}
      disabled={disabled}
      show={show}
      onClose={onClose}
      onSubmit={onSubmit}
      isLoading={isLoading}
    />
  );
};
